import React, { useEffect, useState } from 'react';
import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import DatePicker from '../../DatePicker/DatePicker.component';
import { createAppointment } from '../../../services/appointment.service';
import { Button, makeStyles, TextField, Typography, Grid, 
    Select, MenuItem, InputLabel, Switch } from '@material-ui/core';
import './appointment.scss';
import queryString from 'query-string';
import moment from 'moment';

const AddAppointmentAction = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openConfirmation, setConfirmation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  interface ErrorInputMessage {
  appointment_date?: any;
  appointment_start_time?: any;
  appointment_end_time?: any;
  notes?: string;
  channel?: string;
  duration_in_minutes?: any;
}
  const [errorInputMessage, setErrorInputMessage] =useState<ErrorInputMessage>({});
  const useStyles = makeStyles(() => ({
    field: {
      marginBottom: 10,
      width: '100%'
    },
    select: {
      width: '100%'
    },
    formControl: {
      width: '100%'
    }
  }));
  const classes = useStyles();
  const currentDate = new Date();
  interface AppointmentDetails {
  appointment_date: any;
  appointment_start_time: any;
  appointment_end_time: any;
  notes: string;
  channel: string;
  duration_in_minutes: number;
}
  const [appointmentDetails, setAppointmentDetails] = useState<AppointmentDetails>({
    appointment_date: currentDate.toDateString(),
    appointment_start_time: '08:00',
    appointment_end_time: '10:00',
    notes: "",
    channel: "",
    duration_in_minutes: 0
  });
  const { match } = data;
  const programId = match.params.connect_program_id;
  const queryParams = queryString.parse(data.history.location.search);
  const { patient_id } = queryParams;
  const listOfChannel = [
    {
      value: "face-to-face",
      label: "Face to Face" 
    },
    {
      "value": "call",
      "label": "Call"
    },
    {
      value: "video",
      label: "Video"
    },
    {
      value: "email",
      label: "Email"
    },
    {
      value: "chat",
      label: "Chat"
    }
  ]

  const onClick = async () => {
    setOpenModal(true);
  };

   const handleClose = (reload) => {
    setOpenModal(false);
    setConfirmation(false);
    setErrorMessage(null);
    setErrorInputMessage(null);
    setAppointmentDetails({
      appointment_date: currentDate.toDateString(),
    appointment_start_time: '08:00',
    appointment_end_time: '10:00',
      notes: "",
      channel: "",
      duration_in_minutes: 0
    });

    if (reload) {
      window.location.reload();
    }
  }


   const validateForm = () => {
          const errors: Partial<Record<keyof AppointmentDetails, string>> = {};

        let isValid = true;
      
        if (!appointmentDetails.channel) {
            errors.channel = 'Channel is required';
            isValid = false;
        }

        if (!appointmentDetails.duration_in_minutes) {
            errors.duration_in_minutes = "Duration is required";
            isValid = false;
        }
        if (!appointmentDetails.notes) {
            errors.notes = "Notes is required";
            isValid = false;
        }

        setErrorInputMessage(errors);
        return isValid;
    };

  const onSubmit = async() => {
 if (!validateForm()) {
            console.log("Form invalid");
            return;
        }

    try {
      setLoading(true);
      const userOffsetMinutes = new Date().getTimezoneOffset();    
      const formatDateTime = (date: string, time: string) => {
        return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm')
          .utcOffset(-userOffsetMinutes)
          .toISOString();
      };
  
      const { result, message } = await createAppointment(programId, {
        appointments: [{
          start_datetime: formatDateTime(
            moment(appointmentDetails.appointment_date).format('YYYY-MM-DD'),
            appointmentDetails.appointment_start_time
          ),
          end_datetime: formatDateTime(
            moment(appointmentDetails.appointment_date).format('YYYY-MM-DD'),
            appointmentDetails.appointment_end_time
          ),
          notes: appointmentDetails.notes,
          channel: appointmentDetails.channel,
          duration_minutes: appointmentDetails.duration_in_minutes,
          user_id: patient_id
        }]
      });

      if (result || message) {
        setOpenModal(false);
        setConfirmation(true);
      }
    } catch(err) {
      if (err && err.inputs && err.message === 'ValidationError') {
        setErrorInputMessage(err.inputs);
      } else if (err && err.message) {
        setErrorMessage(err.message);
        alert(err.message);
      }
    } finally {
      setLoading(false);
    }
  }

  const onFieldInput = (e) => {
        const { name, value } = e.target;
        setAppointmentDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
        if (value && errorInputMessage?.[name]) {
            setErrorInputMessage((prev: any) => ({
                ...prev,
                [name]: undefined
            }));
        }
    };


  const onDateChange = (e) => {
    setAppointmentDetails(prevState => ({
      ...prevState,
      ['appointment_date']: e,
    }));
  }

  const onTimePickerChange = (e) => {
    const timeSelected = e.currentTarget.value;
    const name = e.target.name;

    setAppointmentDetails(prevState => ({
      ...prevState,
      [name]: timeSelected,
    }));
  }

  const formContent = (
    <div style={{width: "400px"}}>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <InputLabel>Appointment Date</InputLabel>
            <DatePicker
              required={true}
              onChange={onDateChange}
              name='appointment_date'
              className={classes.field} 
              defaultValue={currentDate}
              value={appointmentDetails.appointment_date}
            />
            <Typography
              variant='caption'
              display='block'
              gutterBottom
              color='error'
            >
            {/* { errorInputMessage ? errorInputMessage.appointment_date : '' } */}
            </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={6}>
          <InputLabel>Start Time</InputLabel>
          <input 
            min="00:00"
            max="23:59"
            type="time"
            name="appointment_start_time"
            value={appointmentDetails.appointment_start_time}
            onChange={onTimePickerChange}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            {/* { errorInputMessage ? errorInputMessage.appointment_start_time : '' } */}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>End Time</InputLabel>
          <input
            min="00:00"
            max="23:59"
            type="time"
            name="appointment_end_time"
            value={appointmentDetails.appointment_end_time}
            onChange={onTimePickerChange}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            {/* { errorInputMessage ? errorInputMessage.appointment_start_time : '' } */}
          </Typography>
        </Grid>
      </Grid>



      <Grid
        item
        container
        xs={12}
        spacing={2}>
        <Grid item xs={6}>
          <InputLabel>Channel</InputLabel>
          <Select 
            required
            label='Channel'
            name="channel"
            value={appointmentDetails.channel}
            variant='outlined' 
            className={classes.field}
            onChange={onFieldInput}
          >
            {
              listOfChannel && listOfChannel.length ? listOfChannel.map(channel => {
                return (
                  <MenuItem key={channel.value} value={channel.value}>
                    {channel.label}
                  </MenuItem>
                )
              }) : <></>
            }
          </Select>
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
                    {errorInputMessage ? errorInputMessage.channel : ''}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <InputLabel>Duration (mins)</InputLabel>
          <TextField className={classes.field} 
            required={true} 
            name='duration_in_minutes'
            type='number' 
            value={appointmentDetails.duration_in_minutes}  
            onChange={onFieldInput}
          />
          <Typography
            variant='caption'
            display='block'
            gutterBottom
            color='error'
          >
            { errorInputMessage ? errorInputMessage.duration_in_minutes : '' }
          </Typography>
        </Grid>
      </Grid>
      <Grid
          item
          container
          xs={12}
          spacing={2}
        >
          <Grid item xs={12}>
              <TextField 
                rows={12}
                multiline={true}
                required={true}
                label='Notes'
                name='notes' 
                value={appointmentDetails.notes}
                variant='outlined'
                className={classes.field}
                onChange={onFieldInput}
                />
              <Typography
                variant='caption'
                display='block'
                gutterBottom
                color='error'
              >
              { errorInputMessage ? errorInputMessage.notes : '' }
              </Typography>
          </Grid>
        </Grid>
    </div>
  );

 

  const formButtons = (
    <>
      <Button onClick={() => handleClose(false)} variant='contained'>
        Close
      </Button>
      <Button onClick={onSubmit} variant='contained' color='secondary'>
        Submit
      </Button>
    </>
  );

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <>
      <Dialog 
      key='create-appointment'
      open={openModal}
      title = 'Create Appointment'
      content = {formContent} 
      children = {formButtons} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(false)} 
      />
     <Dialog 
      key='confirmation'
      open={openConfirmation}
      title = 'Confirmation'
      content = 'Appointment successfully created!' 
      children = {(
        <Button onClick={() => handleClose(true)} variant='contained'>
          Close
        </Button>
      )} 
      onSubmit = {onSubmit}
      onClose = {() => handleClose(true)} 
      />
     <Button variant="contained" color="primary" onClick={onClick} 
     style={{ marginRight: 8, marginBottom: 10 }}>
      + Add Engagement</Button>
    </>
  )
}

export default AddAppointmentAction;
